import React, { useEffect, useMemo, useState } from 'react';
import { IPlayerLevel } from 'utils/types';
import { StyledPlayerLevel } from './style';
import { calculateTimeLeftLabel } from 'templates/PlayerLevel/utils';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

const ENDS_IN_TEXT = 'Ends in: ';

export const LightningLinkSalePlayerLevel: React.FC<IPlayerLevel> = ({
  assetUrl,
  text = [],
  endsIn = 0,
  onTimerDoneHandler,
}) => {
  const topText = useMemo(
    () =>
      Array.isArray(text) ? text.find(({ id }) => id === 'top')?.content : '',
    [text],
  );

  const [bottomText, setBottomText] = useState(
    calculateTimeLeftLabel({ text: ENDS_IN_TEXT, endsIn, onTimerDoneHandler }),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setBottomText(
        calculateTimeLeftLabel({
          text: ENDS_IN_TEXT,
          endsIn,
          onTimerDoneHandler,
        }),
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [endsIn]);

  return (
    <StyledPlayerLevel className={'player-level sale'}>
      <img className={'image'} src={assetUrl} alt={'value player level'} />
      {topText && (
        <div className="top-text-container">
          <AutoTextSize
            maxFontSizePx={32}
            minFontSizePx={2}
            mode="oneline"
            className="top-text"
          >
            {topText}
          </AutoTextSize>
        </div>
      )}
      {bottomText && (
        <div className="bottom-text-container">
          <AutoTextSize
            maxFontSizePx={9}
            minFontSizePx={2}
            mode="multiline"
            className="bottom-text"
          >
            {bottomText}
          </AutoTextSize>
        </div>
      )}
    </StyledPlayerLevel>
  );
};
